// audioContext.js - добавьте глобальный менеджер для совместного использования
class AudioContextManager {
    constructor() {
        this.audioContext = null;
        this.sharedAnalyser = null;
    }

    getAudioContext() {
        if (!this.audioContext) {
            const AudioContext = window.AudioContext || window.webkitAudioContext;
            this.audioContext = new AudioContext();
        }
        return this.audioContext;
    }

    getSharedAnalyser() {
        if (!this.sharedAnalyser && this.audioContext) {
            this.sharedAnalyser = this.audioContext.createAnalyser();
            this.sharedAnalyser.fftSize = 2048;
        }
        return this.sharedAnalyser;
    }

    async resume() {
        if (!this.audioContext) {
            this.getAudioContext();
        }
        if (this.audioContext && this.audioContext.state === 'suspended') {
            await this.audioContext.resume();
        }
        return this.audioContext;
    }
}

window.audioContextManager = new AudioContextManager();